import {Typography} from '@mui/material';
import React, {Fragment, useState} from 'react';

import {AlertInfo} from 'presentation/components';
import {PrepareModal} from 'presentation/modules/myAppointments/ui/components/PrepareModal';
import {translations} from 'presentation/translations-new';
import {ExamInstructionsAlertProps} from './types';

const {appointmentCard} = translations['pt-br'].privateFlow.myAppointments;

export function ExamInstructionsAlert({examName, examNumber}: ExamInstructionsAlertProps) {
	const [openPrepareModalState, setOpenPrepareModalState] = useState<boolean>(false);

	const handleOpenInfoAlert = () => {
		setOpenPrepareModalState(true);
	};

	return (
		<Fragment>
			<AlertInfo.Root>
				<AlertInfo.Description>
					<Typography variant="body2">{appointmentCard.examOrientations}</Typography>

					<AlertInfo.Action onClick={handleOpenInfoAlert} $iconName="appointments-alert">
						{appointmentCard.readOrientations}
					</AlertInfo.Action>
				</AlertInfo.Description>
			</AlertInfo.Root>
			{openPrepareModalState ? (
				<PrepareModal
					examNumber={examNumber}
					setOpen={setOpenPrepareModalState}
					examName={examName}
					open={openPrepareModalState}
				/>
			) : null}
		</Fragment>
	);
}
